<template>
  <div>
    <rest-list
      :payload="fetchEndpoint"
      :filterable="false"
      ref="list"
      :apply-sorting-to-url="false"
      :after-fetch="afterFetch"
    >
      <rest-list-column
        prop="id"
        :title="$t('ProfilePushSubscriptions_Field_Device')"
        :route="deviceRoute"
      />

      <rest-list-column-enum
        prop="type"
        :title="$t('ProfilePushSubscriptions_Field_Type')"
        :enum="DeviceTypeLabel"
      />

      <rest-list-column-enum
        prop="application_id"
        :title="$t('ProfilePushSubscriptions_Field_Application')"
        :enum="applications"
      />

      <rest-list-column
        prop="addressable"
        :title="$t('ProfilePushSubscriptions_Field_Addressable')"
      >
        <template slot-scope="{ row }">
          <div class="status-container">
            <i :class="getAddressableIcon(row.addressable)"></i>
            {{ getAddressableLabel(row.addressable) }}
          </div>
        </template>
      </rest-list-column>

      <rest-list-column
        prop="subscription"
        :title="$t('ProfilePushSubscriptions_Field_Subscription')"
      >
        <template slot-scope="{ row }">
          <div class="status-container">
            <i :class="getSubscriptionIcon(row.subscription)"></i>
            {{ getSubscriptionLabel(row.subscription) }}
          </div>
        </template>
      </rest-list-column>

      <rest-list-column-actions v-if="!readonly">
        <template slot-scope="{ row }">
          <rest-list-action
            v-if="row.subscription"
            icon="el-icon-error"
            :title="$t('ProfilePushSubscriptions_Action_Unsubscribe')"
            :click="updateSubscriptionHandler(row.id, 0)"
          />

          <rest-list-action
            v-if="!row.subscription"
            icon="el-icon-success"
            :title="$t('ProfilePushSubscriptions_Action_Subscribe')"
            :click="updateSubscriptionHandler(row.id, 1)"
          />
        </template>
      </rest-list-column-actions>
    </rest-list>
  </div>
</template>

<script>
import { projectEndpoint, projectRoute, projectUrl } from '@/core/helpers'
import RestApi from '@/core/services/RestApi'
import RestList from '@/common/components/rest/RestList'
import RestListColumn from '@/common/components/rest/RestListColumn'
import { DeviceTypeLabel } from '@/modules/devices/enum/DeviceTypeEnum'
import RestListColumnEnum from '@/common/components/rest/RestListColumnEnum'
import RestListAction from '@/common/components/rest/RestListAction'
import RestListColumnActions from '@/common/components/rest/RestListColumnActions'
import { subscriptionStatusKeys } from '@/modules/profiles/enum/SubscriptionStatusEnum'

export default {
  name: 'ProfilePushSubscriptions',

  components: {
    RestListColumnActions,
    RestListAction,
    RestListColumnEnum,
    RestListColumn,
    RestList
  },

  data() {
    return {
      DeviceTypeLabel
    }
  },

  props: {
    profileId: {
      type: String,
      required: true
    }
  },
  mounted() {},
  computed: {
    readonly() {
      return !this.$can('Device::Update')
    },

    fetchEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: 'devices',
        params: {
          profile_id: this.profileId,
          token_exists: 1
        }
      })
    },

    applications() {
      let list = {}
      this.$store.state.app.applications.forEach(app => {
        list[app.id] = app.name
      })
      return list
    }
  },

  methods: {
    afterFetch() {
      setTimeout(() => {
        document.querySelectorAll('.el-table__expand-icon').forEach(el => {
          el.setAttribute(
            'title',
            this.$t('ProfilePushSubscriptions_Row_ExpandTooltip')
          )
        })
      })
    },

    deviceRoute(row) {
      return projectRoute({
        name: 'Device',
        query: {
          profile_id: row.profile_id,
          device_id: row.id
        }
      })
    },

    updateSubscriptionHandler(deviceId, newValue) {
      return () => this.updateSubscription(deviceId, newValue)
    },

    updateSubscription(deviceId, newValue) {
      RestApi.patch(projectUrl(`devices/${deviceId}`), {
        subscription: newValue
      })
        .then(() => {
          this.$message({
            message: this.$t('Profiles_Channels_UpdateSuccessMessage'),
            type: 'success'
          })

          this.$refs.list.refresh()
        })
        .catch(error => {
          this.$message({
            message: error.message,
            type: 'error'
          })
        })
    },

    getSubscriptionIcon(value) {
      if (value === subscriptionStatusKeys.Unsubscribed) {
        return 'el-icon-error'
      } else if (value === subscriptionStatusKeys.Subscribed) {
        return 'el-icon-success'
      } else if (value === subscriptionStatusKeys.Undefined) {
        return undefined
      }
    },

    getSubscriptionLabel(value) {
      if (value === subscriptionStatusKeys.Unsubscribed) {
        return this.$t('Profiles_Channels_StatusUnsubscribed')
      } else if (value === subscriptionStatusKeys.Subscribed) {
        return this.$t('Profiles_Channels_StatusSubscribed')
      } else if (value === subscriptionStatusKeys.Undefined) {
        return this.$t('Profiles_Channels_StatusNotProvided')
      }
    },

    getAddressableLabel(value) {
      if (value === 1) {
        return this.$t('Profiles_Channels_StatusAddressable')
      } else if (value === 0) {
        return this.$t('Profiles_Channels_StatusNotAddressable')
      }
    },

    getAddressableIcon(value) {
      if (value === 1) {
        return 'el-icon-success'
      } else if (value === 0) {
        return 'el-icon-error'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.status-container {
  display: flex;
  align-items: center;

  &.clickable {
    cursor: pointer;
  }

  i {
    font-size: 18px;
    margin-right: 10px;
  }

  .el-icon-success {
    color: #1fca10;
  }

  .el-icon-error {
    color: #f56c6c;
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/profiles/components/ProfilePushSubscriptions.vue